export default "__VITE_ASSET__JP5foQrh__"